var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70563 9.33039L7.72953 6.03409L7.74178 4.77066C7.74178 2.14014 9.81086 0 12.3542 0H14.6458C17.1891 0 19.2582 2.14014 19.2582 4.77066L19.2987 6.03409L19.2944 9.33039C19.2944 10.9238 18.687 12.3723 17.7006 13.4446C17.7678 13.4483 17.8345 13.4591 17.8996 13.4782C22.1547 13.8769 25.5 17.5866 25.5 22.0897V26.0687C25.5 26.583 25.0969 27 24.5995 27H2.40046C1.90314 27 1.5 26.583 1.5 26.0687V22.0897C1.5 17.5866 4.84531 13.8769 9.10036 13.4782C9.16547 13.4591 9.23219 13.4483 9.29936 13.4446C8.313 12.3723 7.70563 10.9238 7.70563 9.33039ZM17.4572 6.01142V4.77066C17.4572 3.16726 16.1959 1.86268 14.6457 1.86268H12.3543C10.8041 1.86268 9.5428 3.16726 9.5428 4.77066V6.01142H17.4572ZM13.5969 15.1365C11.8033 15.1351 9.03389 15.3654 9.03389 15.3654C5.82346 15.804 3.33707 18.6513 3.33707 22.0897V25.1372H23.6629V22.0897C23.6629 18.6513 21.1765 15.804 17.9661 15.3654C17.9661 15.3654 15.2919 15.1378 13.5969 15.1365ZM17.4572 7.8742V9.33039C17.4572 11.5913 15.6837 13.4319 13.5 13.442C11.3163 13.4319 9.5428 11.5913 9.5428 9.33039V7.8742H17.4572Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.4da3baa635bf7bf84aa5938ef81097b5.svg";
export { ForwardRef as ReactComponent };